import { LoggerFactory, SessionPersistence, SessionStoragePersistence } from '@ibe/services';
import { authService } from '../Hooks/Contexts.js';

class Store {
    token;
}
const logger = LoggerFactory.get('initAuth');
let authSession = new SessionPersistence(Store);
const initAuth = async (config) => {
    logger.log('initAuth...');
    if (!config.sessionKeyTabsShared) {
        authSession = new SessionStoragePersistence(Store);
    }
    authSession.useKey(config.sessionKeyAuth);
    const data = authSession.get();
    logger.log('authSession.get()', data);
    if (data.token) {
        authService.fromJwt(data.token);
    }
};

export { authSession, initAuth };
//# sourceMappingURL=initAuth.js.map
